import jwtDecode from 'jwt-decode'

export default {
  user: {
    uuid: '',
    authenticated: false,
    profile: {},
    socialError: false,
    activatedError: false,
    error: false,
    error_message: '',
    loading: false,
    loadingFB: false,
    require_email: false
  },
  isLoggedIn () {
    const loggedIn = !!localStorage.auth_token
    const expiredToken = (token) => {
      if (token === null) {
        return true
      }
      let decodedToken = jwtDecode(token)
      let now = Date.now() / 1000
      return decodedToken.exp < Number(now.toFixed(0))
    }
    const authToken = (typeof localStorage.auth_token !== 'undefined' && localStorage.auth_token !== null) ? localStorage.auth_token : null
    return loggedIn && !expiredToken(authToken)
  },
  computed: {
    isLoggedIn () {
      const loggedIn = !!localStorage.auth_token
      const expiredToken = (token) => {
        if (token === null) {
          return true
        }
        let decodedToken = jwtDecode(token)
        let now = Date.now() / 1000
        return decodedToken.exp < Number(now.toFixed(0))
      }
      const authToken = (typeof localStorage.auth_token !== 'undefined' && localStorage.auth_token !== null) ? localStorage.auth_token : null
      return loggedIn && !expiredToken(authToken)
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      this.$router.push('/login', () => { this.onChange() })
    },
    onChange () {
      window.location.reload(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js